// extracted by mini-css-extract-plugin
export default {"section":"section-masters_section__CjshN","row":"section-masters_row__3b6CP"};